<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles.js'
	import { get_block_content, get_finished_content, delete_content } from '../library/scripts/utils.js'
	import {
		storeUploader,
		storeActiveBlock,
		storeUpdate,
		storeUpdateSingle,
		storeFinishedContent,
		storeShowFinishedBlocks,
		storeData,
		storeRooms,
		storeFoods,
		storeDrinks,
		storeBooking,
		storeShop,
		storeShowCreateButtons,
	} from '../library/scripts/Store.svelte'
	import { url } from '../library/scripts/Setup.svelte'
	import FileUploader from '../library/FileUploader.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../modals/Alert.svelte'

	export let blockName = null

	//mail answers
	let mailAns1 = 'Thank you for your reservation!'
	let mailAns2 = 'Your Amazing Team'

	//the configFile
	let configFile
	const stoData = storeData.subscribe((value) => {
		configFile = value

		//set the mail answers
		if (value) {
			value.blocks.forEach((block) => {
				if (block.blockName === 'booking') {
					mailAns1 = block.content[0].ans1
					mailAns2 = block.content[0].ans2
				}
			})
		}
	})

	//active block
	const stoActiveBl = storeActiveBlock.subscribe((value) => {
		blockName = value
	})

	let blockTitle
	let showTitle = false
	let stBtnText = 'create title'

	//is this an update
	let isUpdate = false
	let closeUpdate = false
	let uploadCmd = 'upload'
	const stoUpdt = storeUpdate.subscribe((value) => {
		isUpdate = value
	})

	const globals = getContext('globals')
	const colorMain = globals.adminColorMain
	const fsL = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const fsXS = globals.fsXS
	const inputBg = globals.adminInputBg
	const inputBgFocus = globals.adminInputBgFocus
	const buttonBgHover = globals.adminButtonBgHover
	let deleteBlock = false
	let showSave = false

	let showError = false

	//error message
	let message = ''
	let showOkButton = false

	let uploadFiles
	const stoUp = storeUploader.subscribe((value) => {
		uploadFiles = value
	})

	let blocks = get_finished_content()
	blocks.then((value) => {
		storeFinishedContent.set({ finishedBlocks: value.finishedBlocks.sort(), linkedSites: value.linkedSites })
	})

	//update
	$: if (isUpdate) {
		closeUpdate = true
		storeShowCreateButtons.set(false)
		storeActiveBlock.set(blockName)
		uploadCmd = 'update'
		deleteBlock = true
		const blocks = get_block_content(blockName)
		blocks.then(function (value) {
			blockTitle = value[1].blockTitle
			showTitle = true
			stBtnText = 'delete title'
		})
	}

	//promisses
	let uploader = upload_block()

	//functions
	const show_title = () => {
		showTitle = showTitle === false ? true : false
		blockTitle = null
		if (!showTitle) stBtnText = 'create title'
	}

	const save_block = () => {
		//error handling
		let error = false
		if (!blockTitle || blockTitle === '') {
			showError = true
			error = true
			message = 'please add title'
		}

		if (error) return
		if (closeUpdate) uploadCmd = 'update'

		switch (blockName) {
			case 'foods':
				storeFoods.set(false)
				break

			case 'drinks':
				storeDrinks.set(false)
				break

			case 'booking':
				storeBooking.set(false)
				break

			case 'rooms':
				storeRooms.set(false)
				break

			case 'shop':
				storeShop.set(false)
				break
		}

		uploadFiles = false
		storeUploader.set(true)
		uploader = upload_block()
		showSave = false
		storeShowFinishedBlocks.set(true)
		reset_all()
	}

	async function upload_block() {
		return [{ id: blockName, image: null, ans1: mailAns1, ans2: mailAns2 }]
	}

	//close main window
	const close_window = () => {
		const toWait = setTimeout(() => {
			storeShowFinishedBlocks.set(true)
			storeActiveBlock.set(null)
			if ($storeUpdateSingle) {
				document.location = '#/builder'
			}
			clearTimeout(toWait)
		}, 500)
		reset_all()
	}

	const close_alert = () => {
		showError = false
	}

	const alert_delete = () => {
		showError = true
		message = 'delete entire block?'
		showOkButton = true
	}

	const alert_delete_block = async (blockName) => {
		closeUpdate = true
		const remainingBlocks = await delete_content(blockName)

		if (remainingBlocks) {
			showError = false
			remainingBlocks.sort()
			uploadCmd = 'upload'
			storeShowFinishedBlocks.set(true)
			storeFinishedContent.set({ finishedBlocks: remainingBlocks, finishedSites: [] })
			storeActiveBlock.set(null)
			switch (blockName) {
				case 'foods':
					storeFoods.set(true)
					break

				case 'drinks':
					storeDrinks.set(true)
					break

				case 'booking':
					storeBooking.set(true)
					break

				case 'rooms':
					storeRooms.set(true)
					break

				case 'mail':
					storeShowMail.set(false)
					break

				case 'shop':
					storeShop.set(true)
					break
			}
			reset_all()
		}
	}

	const reset_all = () => {
		storeUpdate.set(false)
		storeShowCreateButtons.set(true)
		closeUpdate = false
		deleteBlock = false
		showSave = false
		deleteBlock = false
		showTitle = false
		stBtnText = 'create title'
	}

	onDestroy(() => {
		stoActiveBl
		stoUp
		stoUpdt
		stoData
	})
</script>

{#if blockName && blockName !== 'mail'}
	<main id="updatemenu" use:styles={{ colorMain, fsN }} transition:slide={{ duration: 500 }}>
		<div class="block_title" use:styles={{ fsL, colorMain }}>{blockName}</div>

		<div class="button_container button_left">
			<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={show_title}>{stBtnText}</button>
			{#if showTitle}
				<input
					type="text"
					use:styles={{ inputBg, inputBgFocus, colorMain, fsS }}
					placeholder="enter title"
					bind:value={blockTitle}
					data-input
				/>
			{/if}
		</div>
		<div class="sub_title" data-title use:styles={{ fsS, colorMain }}>Add your Mail Answer</div>
		<div class="sub_title" use:styles={{ fsS, colorMain }}>Line 1</div>
		<input type="text" use:styles={{ inputBg, inputBgFocus, colorMain, fsS }} bind:value={mailAns1} data-input />
		<div class="sub_title" use:styles={{ fsS, colorMain }}>Line 2</div>
		<input type="text" use:styles={{ inputBg, inputBgFocus, colorMain, fsS }} bind:value={mailAns2} data-input />

		<div class="button_container">
			<button on:click={close_window} use:styles={{ colorMain, fsXS, buttonBgHover }}>close</button>
			{#if blockTitle}
				<button on:click={save_block} use:styles={{ colorMain, fsXS, buttonBgHover }}>save</button>
			{/if}
			{#if deleteBlock}
				<button on:click={alert_delete} use:styles={{ colorMain, fsXS, buttonBgHover }}>delete</button>
			{/if}
		</div>
	</main>
{/if}

{#if uploadFiles}
	{#await uploader then upload}
		<FileUploader files={upload} {blockTitle} />
	{/await}
{/if}

{#if showError}
	<Shader>
		<div slot="content">
			<Alert {message} {showOkButton} on:alertok={() => alert_delete_block(blockName)} on:alertclose={close_alert} />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: 95vw;
		display: flex;
		flex-direction: column;
		padding: 2%;
		color: var(--colorMain);
		font-size: var(--fsN);
		user-select: none;
	}

	input[type='text'] {
		background-color: var(--inputBg);
		color: var(--colorMain);
		width: 90%;
		font-size: var(--fsS);
		border: 1px solid green;
	}

	input[data-input] {
		margin-left: 20px;
		width: 60%;
	}

	button {
		background-color: transparent;
		color: var(--colorMain);
		border: 1px solid var(--colorMain);
		font-size: var(--fsXS);
		width: clamp(100px, 13vw, 200px);
		margin-left: 1%;
		padding: 1%;
		border-radius: 5px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonBgHover);
	}

	.button_container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border-top: 1px solid green;
		margin-top: 20px;
		padding-top: 25px;
	}

	.button_left {
		justify-content: flex-start;
	}

	.sub_title {
		color: var(--colorMain);
		font-size: var(--fsS);
		margin-top: 20px;
		margin-bottom: 15px;
	}

	.block_title {
		color: var(--colorMain);
		font-size: var(--fsL);
		text-transform: uppercase;
		font-weight: bold;
		margin: 20px 0px 20px 0px;
	}

	[data-title] {
		margin-top: 30px;
		margin-bottom: 10px;
	}
</style>
